
import { combineReducers } from "redux";

import organizations from "./organizations/Reducer.js";


export default combineReducers({
    organizations
});
